import * as types from "./types";

function dataSaved(payload) {
  return { type: types.DATA_SAVED, payload };
}

function resetDataSaved() {
  return { type: types.RESET_DATA_SAVED };
}

function obtenerPreinscripcionesPorColegio(payload) {
  return { type: types.PREINSCRIPCIONES_POR_COLEGIO, payload };
}

function limpiarPreinscripcionesPorColegio() {
  return { type: types.RESET_PREINSCRIPCIONES_POR_COLEGIO };
}

function onAddedPreinscripcionesDelColegio(payload) {
  return { type: types.ADDED_PREINSCRIPCIONES_DEL_COLEGIO, payload };
}
function onChangedPreinscripcionesDelColegio(payload) {
  return { type: types.CHANGED_PREINSCRIPCIONES_DEL_COLEGIO, payload };
}
function onRemovedPreinscripcionesDelColegio(payload) {
  return { type: types.REMOVED_PREINSCRIPCIONES_DEL_COLEGIO, payload };
}

function limpiarPreinscripcionesDelColegio() {
  return { type: types.RESET_PREINSCRIPCIONES_DEL_COLEGIO };
}

function obtenerDatosColegio(payload) {
  return { type: types.OBTENER_DATOS_COLEGIO, payload };
}

function limpiarDatosColegio() {
  return { type: types.LIMPIAR_DATOS_COLEGIO };
}

function obtenerDatosPreinscripcion(payload) {
  return { type: types.OBTENER_DATOS_PREINSCRIPCION, payload };
}

function limpiarDatosPreinscripcion() {
  return { type: types.LIMPIAR_DATOS_PREINSCRIPCION };
}

function columnaAlumnosSeleccionada(payload) {
  return { type: types.COLUMNA_SELECCIONADA, payload };
}

function resetColumnaAlumnosSeleccionada(payload) {
  return { type: types.RESET_COLUMNA_SELECCIONADA, payload };
}

/*---*/
export {
  dataSaved,
  resetDataSaved,
  obtenerPreinscripcionesPorColegio,
  limpiarPreinscripcionesPorColegio,
  // obtenerPreinscripcionesDelColegio,
  onAddedPreinscripcionesDelColegio,
  onChangedPreinscripcionesDelColegio,
  onRemovedPreinscripcionesDelColegio,
  limpiarPreinscripcionesDelColegio,
  obtenerDatosColegio,
  limpiarDatosColegio,
  obtenerDatosPreinscripcion,
  limpiarDatosPreinscripcion,
  columnaAlumnosSeleccionada,
  resetColumnaAlumnosSeleccionada
};



// WEBPACK FOOTER //
// ./src/ducks/preinscripciones/actions.js